// Menu illustrations, independent of the product-photo library and other models.
const colors = ['pink', 'fuchsia', 'coral', 'honey', 'lemon', 'ivory', 'blue',
  'teal', 'periwinkle', 'chocolate', 'grey', 'red', 'burgundy'];
export const SYLVETTE_MINKY_SWATCHES = Object.fromEntries(colors.map(color => [
  `${color}-minkee`,
  `/images/configurator/sylvette-swatches/v1/${color}-minkee.webp`,
]));
